import React, { Component } from "react";

import $ from "jquery";
import { Link } from "react-router-dom";
import { searchQuestions } from "../../helper/search_helper";
import ListQuestion from "../list/interface/list_question";

import ListHashtags from "../list/interface/list_hahstags";

import QuestionSelection from "./question/question_selection";

class SearchQuestions extends Component {
  state = {
    questions: [],
    current_page: 1,
    total_pages: 1,
    can_load_more: true,
    loaded: false
  };

  constructor(props) {
    super(props);
    //this.handleScroll = this.handleScroll.bind(this);
  }

  render() {
    var questions = this.state.questions.map(question => {
      const alreadySelected = this.questionAlreadySelected(question);

      return (
        <QuestionSelection
          key={question.id}
          question={question}
          questionsSelected={this.props.questionsSelected}
          unselectQuestion={this.props.unselectQuestion}
          selectQuestion={this.props.selectQuestion}
        />
      );
    });

    return <div className="">{questions}</div>;
  }

  handleClickOnQuestion = (question, alreadySelected) => {
    if (alreadySelected) return this.props.selectQuestion(question);
    this.props.unselectQuestion(question);
  };

  questionAlreadySelected(question) {
    for (var i in this.props.questionSelected) {
      if (this.props.questionSelected[i].id === question.id) return true;
    }
    return false;
  }

  componentDidMount() {
    this.getQuestions(1);
  }

  componentDidUpdate() {
    this.getQuestions(1);
  }

  getQuestions(page) {
    if (this.props.query === "") return;

    if (this.state.query === this.props.query) return;

    if (this.searchQuestionsCall) {
      this.searchQuestionsCall.cancel();
    }
    const loaded = page === 0 ? false : true;
    const query = this.props.query;

    this.setState({ can_load_more: false, loaded, query });

    const self = this;
    this.searchQuestionsCall = searchQuestions(this.props.query, page);
    this.searchQuestionsCall.promise
      .then(answer => {
        const can_load_more = true;
        const errors = answer.errors;
        const total_pages = answer.total_pages;
        const loaded = true;
        const questions = answer.questions;
        self.setState({
          can_load_more,
          errors,
          questions,
          total_pages,
          loaded
        });
      })
      .catch(error => {
        const loaded = true;
        const can_load_more = true;
        const errors = error.errors;
        self.setState({ loaded, can_load_more, errors });
      });
  }
}

export default SearchQuestions;



// WEBPACK FOOTER //
// ./src/components/search/search_questions.jsx